'use client'
import { cn } from '@/utils/cn'
import { VariantProps } from 'class-variance-authority'
import { Button, buttonVariants } from '@/shared/ui/button'
import AlarmPrimary from '@/shared/ui/icons/alarm-primary.svg'
import { NotificationButtonProps } from '..'

export const NotificationIconButton = ({
  id,
  price,
  priceLowest,
  alarmBellSize,
  buttonVariant = 'ghost',
  notifiedStatus,
  onClickNotificationButton,
  className,
  ...props
}: NotificationButtonProps & {
  alarmBellSize?: number
  buttonVariant?: VariantProps<typeof buttonVariants>['variant']
}) => {
  return (
    <Button
      variant={buttonVariant}
      size="icon"
      onClick={onClickNotificationButton}
      className={cn(className)}
      {...props}
    >
      <AlarmPrimary
        className={`${alarmBellSize ? `size-${alarmBellSize}` : ''} ${notifiedStatus === 'notified' ? 'text-primary' : 'text-gray-5'}`}
      />
    </Button>
  )
}
